jQuery(function($) {

    var $gridItemSwatches = $(".js-s-grid-item-swatches");
    var $gridItemSwatch = $gridItemSwatches.find('li');

    $gridItemSwatch.click(function() {
        $this_ = $(this);
        $thisContainer = $this_.parent().parent().parent();
        gridItemLink = $thisContainer.parent().find('a').attr('href');
        selectedColor = $this_.data( "value" );
        firstVariantSize = $thisContainer.find(".grid__item-sizes").children("option:selected").val();
        variantName = firstVariantSize + " / " + selectedColor;
        variantNameReverse = selectedColor + " / " + firstVariantSize;

        $grid_variants = $thisContainer.find(".grid__item-variants");

        $foundVariation = $grid_variants.find("[data-name='" + variantName + "']");

        if($foundVariation.length) {
            foundVariationValue = $foundVariation.val();
        } else {
            $foundVariation = $grid_variants.find("[data-name='" + variantNameReverse + "']");
            foundVariationValue = $foundVariation.val();
        }

        if(foundVariationValue) {
            variationLink = location.protocol+'//'+location.hostname + gridItemLink + "?variant=" + foundVariationValue;
            window.location = variationLink;
        }

    });

});

// fetch color swatches (weird fix for shopify bug)
fetch('https://solika.com/pages/color-swatches?view=color-swatches').then(res =>  res.text()).then(res => {
  style = document.createElement('style');
  style.innerHTML = res;
  document.body.appendChild(style)
})